app.controller("ManageRoomsController", ["$scope", "StaticData", "$uibModal", "$stateParams", "TimetableService", "$state", "usSpinnerService",
    function ($scope, StaticData, $uibModal, $stateParams, TimetableService, $state, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.building = $stateParams.building;
        $scope.floor = $stateParams.floor;
        $scope.room = $stateParams.room;
        if ($stateParams.seatCountFrom) $scope.seatCountFrom = $stateParams.seatCountFrom;
        if ($stateParams.seatCountTo) $scope.seatCountTo = $stateParams.seatCountTo;
        if ($stateParams.withComputers == 'true') $scope.withComputers = true;
        if ($stateParams.withSmartBoard == 'true') $scope.withSmartBoard = true;
        $scope.roomList = [];
        $scope.hours = _.range(9, 22);
        $scope.sessionsMap = {};

        StaticData.getItemsByKey("floors").then(function (floors) {
            $scope.floors = [{name: "სართული"}].concat(floors);
            $scope.daysMap = _.keyBy($scope.foors, '_id');
        });

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.daysForTable = _.take(days, 6);
            $scope.days = [{name: "კვირის დღე"}].concat(days);
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        StaticData.getItemsByKey("session_types").then(function (types) {
            $scope.sessionTypes = [{name: "სესიის ტიპი"}].concat(types);
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                building: $scope.building,
                floor: $scope.floor,
                room: $scope.room,
                seatCountFrom: $scope.seatCountFrom,
                seatCountTo: $scope.seatCountTo,
                withComputers: $scope.withComputers,
                withSmartBoard: $scope.withSmartBoard
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            TimetableService.list({
                page: page,
                limit: $scope.itemsPerPage,
                building: $scope.building,
                floor: $scope.floor,
                room: $scope.room,
                seatCountFrom: $scope.seatCountFrom,
                seatCountTo: $scope.seatCountTo,
                withComputers: $scope.withComputers,
                withSmartBoard: $scope.withSmartBoard
            }).then(function (data) {
                $scope.roomList = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
                $scope.sessionsMap = {};
                $scope.roomList.forEach(function (room) {
                    room.sessions.forEach(function (session) {
                        $scope.sessionsMap[room._id] = $scope.sessionsMap[room._id] || {};
                        $scope.sessionsMap[room._id][session.dayOfWeek] = $scope.sessionsMap[room._id][session.dayOfWeek] || {};
                        var startTime = new Date(session.startTime);
                        $scope.sessionsMap[room._id][session.dayOfWeek][startTime.getHours()] = session;
                    })
                })
            });
        }

        $scope.export = function () {
            TimetableService.exportList()
        };

        $scope.getText = function (room) {
            if(room.withComputers && !room.withSmartBoard) return ', კომპიუტერული';
            else if(!room.withComputers && room.withSmartBoard) return ', სმარტ დაფით';
            else if(room.withComputers && room.withSmartBoard) return ', კომპიუტერული, სმარტ დაფით';
        };

        $scope.setSession = function (day, startTime, room) {
            $uibModal.open({
                controller: "DefineInTableController",
                templateUrl: _pb + 'admin/manage/defile-in-table.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {room: room, day: day, startTime: startTime};
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($stateParams.page)
                }, function () {

                });

        };
    }
]);